import {calcDailyBudget} from 'core/DailyBudget';
import {fromStorage} from 'interactors/statePersistence';
import {rewriteState} from 'setup/rewriteState';
import {upgradeBudget} from './upgradeBudget';
import {upgradeRecordKind} from './upgradeRecordKind';

export function rewriteDataStructures(): void {
  const currentState = fromStorage();
  const history = upgradeRecordKind(currentState.history as any);
  const budget = upgradeBudget({...currentState, history} as any);

  const dailyBudget = calcDailyBudget(budget, history);
  const newSettings = {...currentState, budget, history, dailyBudget};
  rewriteState(newSettings, {refresh: false});
}
